import React from "react";
import { Button } from "react-bootstrap";
// import "../../styles/PageContainer.css";
// import 'bootstrap/dist/css/bootstrap.min.css';



const PageContainer = (props) => {
  const { title, buttonText, onButtonClick, children } = props;

  return (
    <div
      className="page-content-wrapper"
      // style={{ backgroundColor: "#F0F8FF", marginTop: "30px", padding: "10px" }}
    >
      <section className="content-header">
        <div className="container">
          <div className="page-container-div">
            <h3 classNme="mb-2 mb-sm-0">{title}</h3>
            {buttonText && (
              <div className="action-buttons">
                <Button className="custom-btn1" onClick={onButtonClick}>
                  {buttonText}
                </Button>
              </div>
            )}
          </div>
        </div>
      </section>
      <section className="content">{children}</section>
    </div>
  );
};

export default PageContainer;
